export default __webpack_public_path__ + "static/media/headArrowDown.c93cda1b.svg";